import React from 'react';
import { useForm } from 'antd/lib/form/Form';
import { Form, notification as Notification } from 'antd';
import { EInvoiceButton } from '../../../components/button';
import { EInvoiceForm } from '../../../components/form/form';
import {
    EInvoiceInput,
    EInvoiceInputPassword,
} from '../../../components/form/input';
import { useDispatch } from 'react-redux';
// import { setLoading } from '../../../redux/slices/appInfo';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ICCheckFill, ICClose, ICWarning } from '../../../icons';

type NotificationType = 'success' | 'info' | 'warning' | 'error';

const Wrapper = styled.div`
    background-color: #088947;
    background-image: url('/images/bg-pattern.png');
    background-size: cover;
    background-repeat: no-repeat;
`;

type FieldType = {
    firstName?: string;
    lastName?: string;
    email?: string;
    password?: string;
};

export const RegisterPage: React.FC = () => {
    const dispatch = useDispatch();
    const [registerForm] = useForm();

    const [api, contextHolder] = Notification.useNotification();
    const openNotification = React.useCallback(
        (
            type: NotificationType,
            title: React.ReactNode,
            description?: React.ReactNode
        ) => {
            if (type === 'success') {
                api[type]({
                    icon: <ICCheckFill />,
                    message: (
                        <span className="text-high-em text-body-bold">
                            {title}
                        </span>
                    ),
                    description,
                    placement: 'bottom',
                    className: 'middle-notification',
                    closeIcon: (
                        <ICClose height={18} width={18} fill={'#4F4B5C'} />
                    ),
                });
            }
            if (type === 'error') {
                return api[type]({
                    icon: <ICWarning fill="#F03D3D" />,
                    message: (
                        <span className="text-body-bold text-high-em">
                            {title}
                        </span>
                    ),
                    description,
                    placement: 'bottom',
                    className: 'middle-notification',
                    closeIcon: (
                        <ICClose height={18} width={18} fill={'#4F4B5C'} />
                    ),
                });
            }
        },
        [api]
    );

    const onFinished = React.useCallback(async () => {
        // try {
        // } catch (error) {
        //     dispatch(setLoading(false));
        //     openNotification(
        //         'error',
        //         'Register failed',
        //         'Please check your email and password'
        //     );
        // }
    }, [dispatch, openNotification]);

    return (
        <Wrapper className="flex w-screen h-screen items-center justify-center bg-surface-low">
            {contextHolder}
            <div className="shadow-e-03 max-md:max-w-[478px] max-md:w-auto w-[478px] p-[32px] flex flex-col gap-[24px] rounded-[12px] overflow-hidden box-border bg-white">
                <div className="flex justify-center">
                    <h1 className="text-heading-5 text-high-em font-semibold">
                        Register your account
                    </h1>
                </div>
                <EInvoiceForm
                    form={registerForm}
                    name="registerForm"
                    layout="vertical"
                    labelCol={{ span: 8 }}
                    onFinish={onFinished}
                    childNode={
                        <>
                            <div className="form flex flex-col w-full gap-[16px]">
                                <div>
                                    <Form.Item<FieldType>
                                        label="First Name"
                                        name="firstName"
                                        rules={[
                                            {
                                                required: true,
                                                whitespace: true,
                                                message:
                                                    'Please input your first name!',
                                            },
                                        ]}
                                    >
                                        <EInvoiceInput
                                            size="large"
                                            maxLength={50}
                                            placeholder="First Name"
                                        />
                                    </Form.Item>
                                </div>
                                <div>
                                    <Form.Item<FieldType>
                                        label="Last Name"
                                        name="lastName"
                                        rules={[
                                            {
                                                required: true,
                                                whitespace: true,
                                                message:
                                                    'Please input your last name!',
                                            },
                                        ]}
                                    >
                                        <EInvoiceInput
                                            size="large"
                                            maxLength={50}
                                            placeholder="Last Name"
                                        />
                                    </Form.Item>
                                </div>
                                <div>
                                    <Form.Item<FieldType>
                                        label="Email"
                                        name="email"
                                        rules={[
                                            {
                                                required: true,
                                                whitespace: true,
                                                message:
                                                    'Please input your email!',
                                            },
                                        ]}
                                    >
                                        <EInvoiceInput
                                            size="large"
                                            maxLength={50}
                                            placeholder="Email"
                                        />
                                    </Form.Item>
                                </div>
                                <div>
                                    <Form.Item<FieldType>
                                        label="Password"
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    'Please input your password!',
                                            },
                                        ]}
                                    >
                                        <EInvoiceInputPassword
                                            size="large"
                                            maxLength={20}
                                            placeholder="Password"
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="flex flex-col w-full gap-[24px] pt-[16px]">
                                <div>
                                    <EInvoiceButton htmlType="submit">
                                        Register
                                    </EInvoiceButton>
                                </div>
                                <div className="flex gap-[16px] items-center justify-center text-center text-high-em text-body">
                                    <Link
                                        to="/login"
                                        className="underline text-info-500 font-medium"
                                    >
                                        Back to login
                                    </Link>
                                </div>
                            </div>
                        </>
                    }
                />
            </div>
        </Wrapper>
    );
};
